﻿export default class PlanStatus {
  static get AvailableNow() {
    return this.getInstance('A');
  }

  static get Model() {
    return this.getInstance('M');
  }

  static get ReadyToBuild() {
    return this.getInstance('R');
  }

  static get UnderConstruction() {
    return this.getInstance('UC');
  }

  static get HotDeals() {
    return this.getInstance('H');
  }

  static fromKey(key) {
    const statusMap = {
      R: PlanStatus.ReadyToBuild,
      A: PlanStatus.AvailableNow,
      UC: PlanStatus.UnderConstruction,
      M: PlanStatus.Model,
      H: PlanStatus.HotDeals,
    };
    return statusMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new PlanStatus(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(PlanStatus, 'instances', { value: {} });
